

















import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useState } = createNamespacedHelpers('biura');

import { UA } from '@/node_modules/nuxt-user-agent/lib/types';
import { UseRainbowContext } from '~/context/RainbowContext';
import mapBreadcrumbsToJsonLd from '~/jsonLd/functions/mapBreadcrumbsToJsonLd';
import IBreadcrumbsJsonLdParams from '~/jsonLd/types/IBreadcrumbsJsonLdParams';

export default defineComponent({
  setup() {
    const { routeInfo } = useState(['routeInfo']);
    const breadcrumbs = computed(() => routeInfo.value.Breadcrumbs);
    const { $ua }: { $ua: UA } = UseRainbowContext();
    const breadcrumbsIsTruncated = ref(true);
    const showDots = computed(() => breadcrumbs.value.length > 3 && $ua.isFromSmartphone());
    // eslint-disable-next-line max-len
    const breadcrumbsToShow = computed(() => (breadcrumbsIsTruncated.value && showDots.value ? breadcrumbs.value.slice(-2) : breadcrumbs.value));
    const getJsonLdProps = (): IBreadcrumbsJsonLdParams => ({
      breadcrumbs: breadcrumbs.value,
      host: 'https://r.pl',
    });

    return {
      breadcrumbs,
      checkLastItem: (index: number) => {
        const shift: number = breadcrumbs.value.length - breadcrumbsToShow.value.length;

        return breadcrumbs.value.length - 1 === index + shift;
      },
      showDots,
      showFullBreadcrumbs: () => {
        breadcrumbsIsTruncated.value = false;
      },
      breadcrumbsToShow,
      breadcrumbsIsTruncated,
      jsonLd: computed(() => mapBreadcrumbsToJsonLd(getJsonLdProps())),
    };
  },
  jsonld() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.jsonLd as any;
  },
});
